import type {
  DataAuditAuditByAtsIdNodeApi,
  DataAuditAuditDetailApi,
} from 'src/components/data-audit/types';

import type {StatusSemantic} from './label-types';


export function parseDataAuditJsonForView(
  value: string | null | undefined,
): unknown {
  if (!value) {
    return '-';
  }

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export function getLatestHttpAuditStatusCode(
  httpAudits: Array<{response: {statusCode: number}}>,
): number | null {
  if (httpAudits.length === 0) {
    return null;
  }

  return httpAudits[httpAudits.length - 1]?.response.statusCode ?? null;
}

export function getLatestAuditFromNode(
  node: DataAuditAuditByAtsIdNodeApi,
): DataAuditAuditDetailApi | null {
  const audits = node.audits ?? [];

  if (audits.length === 0) {
    return null;
  }

  return [...audits].sort(
    (left, right) =>
      new Date(left.timeInfo?.timeCreated ?? 0).getTime() -
      new Date(right.timeInfo?.timeCreated ?? 0).getTime(),
  )[audits.length - 1];
}

export function getHttpAuditResponseMessageValue(
  latestHttpAudit:
    | {
        response: {body: string};
      }
    | null
    | undefined,
  auditError?: string,
): unknown {
  if (auditError) {
    return auditError;
  }

  const responseBody = latestHttpAudit?.response.body;

  if (!responseBody) {
    return '-';
  }

  try {
    const parsed = JSON.parse(responseBody) as Record<string, unknown>;
    const errorMessage = parsed.errorMessage;
    const message = parsed.message;

    if (typeof errorMessage === 'string' && errorMessage) {
      return errorMessage;
    }

    if (typeof message === 'string' && message) {
      return message;
    }

    return parsed;
  } catch {
    return responseBody;
  }
}

export function getWritebackTimelineIcon(statusSemantic: StatusSemantic): {
  iconName: string;
  iconColor: 'danger' | 'success' | 'neutral';
} {
  if (statusSemantic === 'danger') {
    return {iconName: 'triangle-exclamation', iconColor: 'danger'};
  }

  if (statusSemantic === 'success') {
    return {iconName: 'circle-check', iconColor: 'success'};
  }

  return {iconName: 'circle-info', iconColor: 'neutral'};
}
